module.exports = __webpack_public_path__ + "static/leopard5-0762ab910b23d59a77102d134def1d80.png";